/** The shape a tile is drawn at: a picture's own, kept from being a sliver or a tower. */
export function tileRatio(ratio: number): number {
  return ratio > 0 ? Math.max(0.4, Math.min(2.5, ratio)) : 0;
}

/**
 * Which of two columns each picture stands in: always the shorter one, in the order they
 * came. So a second page of pictures is set under the first and nothing already on screen
 * moves — CSS columns balance the whole list again each time it grows, and everything
 * somebody was looking at jumped to the other side.
 *
 * `ratios` are width over height; a picture whose shape is not known counts as a square.
 */
export function twoColumns(ratios: readonly number[]): [number[], number[]] {
  const columns: [number[], number[]] = [[], []];
  const heights = [0, 0];
  ratios.forEach((ratio, index) => {
    const side = heights[1]! < heights[0]! ? 1 : 0;
    columns[side].push(index);
    heights[side]! += 1 / (tileRatio(ratio) || 1);
  });
  return columns;
}
